import qualityEventsHelpers from '../../services/quality-events/quality-events.helpers';
import debounce from '../../utils/debounce';
import { CatalogProps } from '../../utils/enhanced-ecommerce';

const recoSliderImpressionHelper = (function () {
    const cache = {};
    // @ts-ignore
    let toBetracked = [];

    const trackImpression = () => {
        // @ts-ignore
        qualityEventsHelpers.trackMaterialList(toBetracked, {
            type: 'appearedInRecoSlider'
        });
        toBetracked = [];
    };

    const debouncedRequest = debounce(trackImpression, 1000);

    return {
        track(item: Material, params: CatalogProps) {
            if (!cache[item.id]) {
                // track

                // @ts-ignore
                toBetracked.push(qualityEventsHelpers.extractMaterialsData(item, params));
                debouncedRequest();

                cache[item.id] = true;
            }
        }
    };
})();

export default recoSliderImpressionHelper;
